import AbstractService from 'services/AbstractService';

class ContactService extends AbstractService {
    constructor() {
        super();
        this.CONTACT_SEND_START = 'CONTACT_SEND_START';
        this.CONTACT_SEND_SUCCESS = 'CONTACT_SEND_SUCCESS';
        this.CONTACT_SEND_ERROR = 'CONTACT_SEND_ERROR';

        this.baseUrl = process.env.REACT_APP_BASE_URL;
    }

    contact(name, email, message) {
        this.dispatch(
            {
                type: this.CONTACT_SEND_START,
                name,
                email,
                message
            }
        );
    }
}

export default new ContactService();



// WEBPACK FOOTER //
// ./src/services/ContactService.js